import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

class WebComponent extends HTMLElement {
  connectedCallback() {
    const type = this.getAttribute("type");
    ReactDOM.render(<App type={type} />, this);
  }
}

const ELEMENT_ID = "voebiz-react-my-flights";

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
